import API from '@/services/endpoint'
import { SET_CURRENT_BOOKING_EVENT } from "../../mutation-types";

/**
 * Set current clicked event to be booked
 * @param {function} commit - The vuex commit function
 * @param payload
 * @param {object} state - The vuex state object
 * @return {object} A object of current event
 */
export async function setCurrentEvent({commit}, payload) {
  commit(SET_CURRENT_BOOKING_EVENT, payload)
}

/**
 * Post request for event reservation
 * @param {function} commit - The vuex commit function
 * @param payload
 * @param {object} state - The vuex state object
 * @return {object} A object of current event information
 */
export function postEventHandler({commit, state}, payload) {
  return new Promise(async (resolve, reject) => {
    try {
      const { url } = state
      let responseObj = await API.post(url, payload);
      let { data: { success } } = responseObj;
      resolve(success)
    } catch (e) {
      reject(e.response.data)
    }
  })
}
